var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Button } from 'ui/styled';
import { isCallInProgress, isIncoming } from 'pages/NIC/hooks/useCallStates';
import { nicService } from 'stores/nic/services/nicService';
import { selectCalls, useCallStore } from 'stores/nic/stores/callStore';
import { Container, Title, Message } from './styled';
var InactiveTabView = function () {
    var _a;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var hasActiveCall = useCallStore(function (state) { return state.hasActiveCall; });
    var calls = useCallStore(selectCalls);
    // A ringing call can be answered straight from here, which saves the user from
    // finding the active tab. A call that is already up cannot: taking WebRTC over
    // mid-call would cut the audio in the tab that is handling it, so that case
    // keeps the button blocked.
    var incomingCall = calls.some(function (c) { var _a; return isCallInProgress((_a = c.call) === null || _a === void 0 ? void 0 : _a.status); })
        ? null
        : (_a = calls.find(function (c) { var _a; return isIncoming((_a = c.call) === null || _a === void 0 ? void 0 : _a.status); })) === null || _a === void 0 ? void 0 : _a.call;
    // Check if there's actually an active owner tab and take over if none exists
    useEffect(function () {
        var checkAndTakeOver = function () { return __awaiter(void 0, void 0, void 0, function () {
            var ownerTabId, pingChannel, ownerResponded, handleResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ownerTabId = localStorage.getItem('webRtcOwnerTabId');
                        if (!!ownerTabId) return [3 /*break*/, 2];
                        // No owner at all - take over immediately
                        setLoading(true);
                        return [4 /*yield*/, nicService.takeOverWebRtc()];
                    case 1:
                        _a.sent();
                        setLoading(false);
                        return [2 /*return*/];
                    case 2:
                        pingChannel = new BroadcastChannel('nic-owner-ping');
                        ownerResponded = false;
                        handleResponse = function () {
                            ownerResponded = true;
                        };
                        pingChannel.onmessage = handleResponse;
                        pingChannel.postMessage({ type: 'ping' });
                        // Wait for response
                        setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!!ownerResponded) return [3 /*break*/, 2];
                                        // No response - owner is dead, take over
                                        setLoading(true);
                                        return [4 /*yield*/, nicService.takeOverWebRtc()];
                                    case 1:
                                        _a.sent();
                                        setLoading(false);
                                        _a.label = 2;
                                    case 2:
                                        pingChannel.close();
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 1000);
                        return [2 /*return*/];
                }
            });
        }); };
        checkAndTakeOver();
    }, []);
    var handleTakeOverSession = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 6, 7]);
                    if (!incomingCall) return [3 /*break*/, 3];
                    return [4 /*yield*/, nicService.takeOverWebRtcAndAcceptCall(incomingCall.contactID)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, nicService.takeOverWebRtc()];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var getMessage = function () {
        if (incomingCall) {
            return 'A call is ringing in another tab. Click below to activate this tab and answer the call here.';
        }
        return hasActiveCall
            ? 'Another tab is currently handling an active call. Wait until the call ends to activate this tab.'
            : 'Another tab is currently handling the call session. Click below to activate this tab for calls.';
    };
    return (_jsxs(Container, { children: [_jsx(Title, { children: incomingCall
                    ? 'Incoming call in another tab'
                    : 'Switch to active tab to operate calls' }), _jsx(Message, { children: getMessage() }), _jsx(Button, { onClick: handleTakeOverSession, btntype: "primary", btnsize: "custom", loading: loading, padding: "8px 16px", disabled: hasActiveCall && !incomingCall, children: incomingCall ? 'Activate This Tab & Accept' : 'Activate This Tab' })] }));
};
export default InactiveTabView;
